export interface Theme {
  name: string;
  bg: string;
  textPrimary: string;
  textBright: string;
  textDim: string;
  textAccent: string;
  scrollbarThumb: string;
  scrollbarThumbHover: string;
  scanlines: boolean;
  glow: string | null;
  fontFamily: string;
  fontUrl: string | null;
  fontSize: string;
  lineHeight: string;
  letterSpacing: string;
  fontWeight: string;
  bgOverlay: string | null;
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.style.setProperty("--term-bg", theme.bg);
  root.style.setProperty("--term-text", theme.textPrimary);
  root.style.setProperty("--term-bright", theme.textBright);
  root.style.setProperty("--term-dim", theme.textDim);
  root.style.setProperty("--term-accent", theme.textAccent);
  root.style.setProperty("--term-scrollbar", theme.scrollbarThumb);
  root.style.setProperty("--term-scrollbar-hover", theme.scrollbarThumbHover);
  root.style.setProperty("--term-glow", theme.glow ?? "none");
  root.style.setProperty("--term-font-family", theme.fontFamily);
  root.style.setProperty("--term-font-size", theme.fontSize);
  root.style.setProperty("--term-line-height", theme.lineHeight);
  root.style.setProperty("--term-letter-spacing", theme.letterSpacing);
  root.style.setProperty("--term-font-weight", theme.fontWeight);
  root.style.setProperty("--term-bg-overlay", theme.bgOverlay ?? "none");
  root.dataset.scanlines = String(theme.scanlines);

  if (theme.fontUrl) {
    const existing = document.querySelector("link[data-theme-font]");
    if (!existing) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.setAttribute("data-theme-font", "true");
      link.href = theme.fontUrl;
      document.head.appendChild(link);
    } else {
      existing.setAttribute("href", theme.fontUrl);
    }
  }
}
